import React, { ReactNode } from 'react'
import styled from '@emotion/styled'
import { colors, font, radius, spacing } from '@mobi/component-library/Theme/Common'

export const Badge: React.FC<{
  children: ReactNode
}> = ({ children }) => <BadgeStyled>{children}</BadgeStyled>

const BadgeStyled = styled.span({
  boxSizing: 'border-box',
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0 ' + spacing.smx1,
  width: '2.1rem',
  height: '0.9rem',
  fontSize: '0.6rem',
  borderRadius: radius.smx2,
  fontWeight: font.weight.medium,
  letterSpacing: '0.06rem',
  fontStyle: 'italic',
  color: colors.error['50'],
  backgroundColor: colors.error['500'],
})
